import React from 'react';
import useEnlog from 'app/hook/common/useEnlog';

import classNames from 'classnames/bind';
import styles from './InputCheckBox.module.scss';
import '@encarpkg/design/dist/brandLogo.css';

const cx = classNames.bind(styles);

const InputCheckBox = (props) => {
	const {
		title = '',
		id,
		name,
		value,
		label = '',
		labelSize = '14',
		onChange = () => {},
		useTitle = false,
		isBig = false,
		disabled = false,
		isManufact = false,
		code = '',
		style = null,
		onClick = undefined,
		readOnly = undefined,
		useDark = false,
		labelStyle = null,
	} = props;

	const { propsDataset } = useEnlog();
	const dataSet = propsDataset(props);

	return (
		<span
			className={cx('dIB', { dark: useDark })}
			style={style}
		>
			{useTitle && <p className={cx('title')}>{title}</p>}
			<span className={cx('uiinput', { big: isBig }, { manufact: isManufact })}>
				<input
					readOnly={readOnly}
					type="checkbox"
					id={id}
					name={name}
					checked={value}
					onChange={onChange}
					onClick={onClick}
					disabled={disabled}
					{...dataSet}
				/>
				<label
					htmlFor={id}
					className={cx('txt_item', `label_size${labelSize}`)}
					style={labelStyle}
				>
					<span className={cx({ uiico_brand: isManufact }, { [`icon_${code}`]: isManufact })}>
						{typeof label === 'string' ? label.replace('$n', '\n') : label}
					</span>
				</label>
			</span>
		</span>
	);
};

export default InputCheckBox;
